import React from "react";

export default function ProfileCard() {
  return (
    <div className="max-w-4xl mx-auto flex items-center gap-2 lg:gap-8 lg:p-8 bg-white ">
      <img src="/brett.png" alt="Profile" className="lg:w-52 w-auto max-lg:max-w-[150px] lg:h-60 object-cover " />

      <div className="flex-1">
        <h2 className="text-lg lg:text-2xl font-extrabold text-black">Brett Fourie</h2>
        <h3 className="text-[0.7rem] lg:text-xl font-semibold text-green-600 mt-1">
          Head of Video Production Sales
        </h3>
        <p className="text-gray-700 text-[0.4rem] lg:text-base mt-4 leading-relaxed">
          Brett’s expertise comes from his 10-plus years in the video production
          industry and 15 years in marketing and advertising services. He knows
          how to identify your ideal target audience and understand their
          ‘buyer’ mindset to position your film’s pre-production,
          post-production, or animation services as the perfect solution to
          their needs.
        </p>
      </div>
    </div>
  );
}
